import { EnabledAction, ScopeOption } from "../../../../../models/CommonModel";

/**
 * A pending, unsaved scope change for either an object capability (Read/Write on
 * a Common Model) or a single field. Edits are recorded locally and only flushed
 * to the API on Save.
 */
export interface ModelCapabilityEdit {
  kind: "model";
  modelName: string;
  capability: EnabledAction;
  scope: ScopeOption;
}

export interface FieldEdit {
  kind: "field";
  modelName: string;
  fieldName: string;
  scope: ScopeOption;
}

export type ScopeEdit = ModelCapabilityEdit | FieldEdit;

/** Pending edits keyed so re-editing the same target overwrites the prior choice. */
export type ScopeEditsMap = Record<string, ScopeEdit>;

export const modelEditKey = (modelName: string, capability: EnabledAction) =>
  `model::${modelName}::${capability}`;

export const fieldEditKey = (modelName: string, fieldName: string) =>
  `field::${modelName}::${fieldName}`;
